<template>
  <div pr-slide-or-not>
    <template v-if="sect === 'sm'">
      <div :id="id">
        <h3 class="q">{{ title }}</h3>
        <slot name="top" />
        <div class="q" pr-slide-in-video-cover :style="{ backgroundImage: img ? `url('${img}')` : 'none' }">
          <video v-if="video" :src="video" muted autoplay loop playsinline />
          <GridBase alpha50>
            <slot />
          </GridBase>
        </div>
      </div>
    </template>
    <template v-else-if="sect === 'md'">
      <div :id="id">
        <div class="q" pr-slide-in-video-cover :style="{ backgroundImage: img ? `url('${img}')` : 'none' }">
          <video v-if="video" :src="video" muted autoplay loop playsinline />
          <GridBase alpha50>
            <h3 class="q">{{ title }}</h3>
            <slot name="top" />
            <slot />
          </GridBase>
        </div>
      </div>
    </template>
    <PrSlideIn v-else :title="title" :titleSub="titleSub" :video="video" :img="img" :id="id" :direction="direction">
      <template v-slot:stay>
        <slot name="stay" />
      </template>
      <template v-slot:default>
        <slot name="slide" />
      </template>
    </PrSlideIn>
  </div>
</template>

<script>
import GridBase from "@/views/components/GridBase";
import PrSlideIn from "@/views/components/PrSlideIn";

export default {
  name: "PrSlideOrNot",
  components: { PrSlideIn, GridBase },
  props: {
    title: {
      type: String,
      default: "",
    },
    titleSub: {
      type: String,
      default: "",
    },
    video: { type: String },
    img: { type: String },
    id: { type: String },
    direction: { default: "r2l" },
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

[pr-slide-in-video-cover] {
  .hf;
  .rel;
  overflow: hidden;
  .cover;
  .bg-c;

  video {
    .abs;
    .lt(50%, 50%);
    .min-h(100%);
    .min-w(100%);
    transform: translate(-50%, -50%);
  }
}
</style>
